import React from "react";

const Info = () =>{
    return(
        <>User</>       
    )
}

export default Info